import LinkTag from '@/src/component/LinkTag';
import { UrlValidator } from '@/src/utils/validators';
import ArrowUpRightFromSquare from '@/asset/superstack/svgs/arrow-up-right-from-square.svg';

const UrlLinkButtonBlock = ({
  url,
  target = '_blank',
  rel = 'external noopener',
  style,
  ...props
}) => {
  if (!url) {
    return null;
  }
  let url_ = url;
  if (!url_.includes('https://') && !url_.includes('http://')) {
    url_ = 'http://' + url_;
  }
  const isValidUrl = UrlValidator(url_);
  return (
    <>
      {isValidUrl && (
        <LinkTag
          isNextPage={false}
          href={url_}
          target={target}
          rel={rel}
          style={{
            textDecoration: 'none',
            color: '#0000EE',
            width: '100%',
            ...style,
          }}
        >
          {props.children}
        </LinkTag>
      )}
      {!isValidUrl && <a style={{ ...style }}>{url}</a>}
    </>
  );
};

const UrlLink = ({ url, target = '_blank', rel = 'external noopener', style }) => {
  if (!url) {
    return null;
  }
  let url_ = url;
  if (!url_.includes('https://') && !url_.includes('http://')) {
    url_ = 'http://' + url_;
  }
  const isValidUrl = UrlValidator(url_);
  return (
    <>
      {isValidUrl && (
        <LinkTag
          isNextPage={false}
          href={url_}
          target={target}
          rel={rel}
          style={{
            textDecoration: 'none',
            color: '#0000EE',
            ...style,
          }}
        >
          {url_}
        </LinkTag>
      )}
      {!isValidUrl && <a style={{ ...style }}>{url}</a>}
    </>
  );
};

const UrlLinkMobile = ({
  url,
  target = '_blank',
  rel = 'external noopener',
  style,
  width = 14,
  height = 14,
  ...props
}) => {
  if (!url) {
    return null;
  }
  let url_ = url;
  if (!url_.includes('https://') && !url_.includes('http://')) {
    url_ = 'http://' + url_;
  }
  const isValidUrl = UrlValidator(url_);
  return (
    <>
      <LinkTag
        isNextPage={false}
        href={isValidUrl ? url_ : url}
        target={target}
        rel={rel}
        style={{
          textDecoration: 'none',
          color: '#0000EE',
          ...style,
        }}
      >
        {props.children}
        <ArrowUpRightFromSquare width={width} height={height} />
      </LinkTag>
    </>
  );
};

const NaverMapLink = ({ query, style }) => {
  const baseUrl = 'https://map.naver.com/v5/search/';
  const url = baseUrl + query;
  return (
    <LinkTag
      isNextPage={false}
      href={url}
      target={'_blank'}
      rel={'external noopener'}
      style={{
        textDecoration: 'none',
        color: '#006DFF',
        ...style,
      }}
    >
      지도 보기
    </LinkTag>
  );
};

export { UrlLinkButtonBlock, UrlLink, UrlLinkMobile, NaverMapLink };
